<!-- Breadcrumb -->
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a routerLink="">Home</a>
    </li>
    <li class="breadcrumb-item">Minha Conta</li>
    <li class="breadcrumb-item active">
      Cadastro
    </li>
  </ol>
<!-- //.Breadcrumb -->

<h4 class="page-header title-300">Participação nos Sorteios da Campanha Nota Premiada Bahia</h4>

<!-- Card Flex -->
<div *ngIf="consumidor.statusParticipanteSorteio !== 0">
<div class="row">
  <div class="col-12">
    <div class="card card-flex">
      <div class="card-body">
        <h5 class="title-300">Você está participando dos sorteios da Campanha Nota Premiada Bahia.</h5>
        <p><b>Cadastro realizado:</b> {{ consumidor.dataCadastro | date: 'dd/MM/yyyy' }}</p>
      </div>
    </div>
  </div>
</div>
</div>
<!-- //.Card Flex -->

<!-- Card Flex -->
<div *ngIf="consumidor.statusParticipanteSorteio === 0">
<div class="row">
  <div class="col-12">
    <div class="card card-flex">
      <div class="card-body">
        <h5 class="title-300">Você não está participando dos sorteios da Campanha Nota Premiada Bahia.</h5>
        <p><b>Cadastro realizado:</b> {{ consumidor.dataCadastro | date:'dd/MM/yyyy' }}</p>
      </div>
    </div>
  </div>
</div>
</div>
<!-- //.Card Flex -->

<br>

<h4 class="page-header title-300">Endereço e Contatos</h4>

<!-- Card Flex -->
<div class="card card-flex">
  <div class="card-body">

    <dl class="row">       
      <dt class="col-sm-3">CEP:</dt>
      <dd class="col-sm-9">{{ consumidor.cep | cepMask }}&nbsp;</dd>   
    </dl>

    <dl class="row">
      <dt class="col-sm-3">Município:</dt>
      <dd class="col-sm-9">{{ municipio.nome }}&nbsp;</dd>
    </dl>

    <dl class="row">
      <dt class="col-sm-3">UF:</dt>
      <dd class="col-sm-9">{{ municipio.unidadeFederacaoId }}&nbsp;</dd>
    </dl>


    <dl class="row">
      <dt class="col-sm-3">Tel. Contato:</dt>
      <dd class="col-sm-9">{{ consumidor.dddTelefone + '' + consumidor.telefone | telefoneMask }}&nbsp;</dd>
    </dl>

    <dl class="row">
      <dt class="col-sm-3">Tel. Opcional:</dt>
      <dd class="col-sm-9">{{ consumidor.dddCelular + '' + consumidor.celular | telefoneMask }}&nbsp;</dd>
    </dl>

    <dl class="row">
      <dt class="col-sm-3">E-mail Principal:</dt>
      <dd class="col-sm-9">{{ consumidor.emailPrincipal }}&nbsp;</dd>
    </dl>

    <dl class="row">
      <dt class="col-sm-3">E-mail Opcional:</dt>
      <dd class="col-sm-9">{{ consumidor.emailOpcional }}&nbsp;&nbsp;</dd>
    </dl>

    <dl class="row" *ngIf="this.consumidor.codOrigemCadastro!=2">
      <dt class="col-sm-3">Frase de Segurança:</dt>
      <dd class="col-sm-9">{{ consumidor.fraseSeguranca }}&nbsp;</dd>
    </dl>

    <div class="row">
      <div class="col-12 text-right">
        <button type="button" class="btn btn-bluelight" (click)="onDetalharClick()"
        data-toggle="tooltip" data-placement="top" title="Alterar Cadastro">Alterar Cadastro</button>
        <button type="button" class="btn btn-bluelight" (click)="onAlteraSenha()"  *ngIf="this.consumidor.codOrigemCadastro!=2 ||
        this.consumidor.codOrigemCadastro == 2 && this.consumidor.senhaCadastrada == true"
        data-toggle="tooltip" data-placement="top" title="Alterar Senha">Alterar Senha</button>
      </div>
    </div>

  </div>
</div>
<!-- //.Card Flex -->

<h4 class="page-header title-300">Sair da Campanha Nota Premiada Bahia</h4>

<!-- Card Flex -->
<div class="row">
  <div class="col-12">
    <div class="card card-flex">
      <div class="card-body text-center">
        <h5 class="title-300">Você deseja descadastrar-se da Campanha Nota Premiada Bahia?</h5>
        <button type="button" class="btn btn-bluelight" (click)="onDescadastrarConsumidor()"
        data-toggle="tooltip" data-placement="top" title="Descadastre-se">Descadastre-se</button>
      </div>
    </div>
  </div>
</div>
<!-- //.Card Flex -->



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-detalhar/consumidor-detalhar.component.html